/**
 * SIMS-8826 — the notice shown once a copy exists. The design's wording (markup L1061), naming the
 * copy the server actually created, since the suffix is only known once it has picked a free name.
 */
export const duplicateCreatedNotice = (copyName: string): string =>
	`Duplicate created as “${copyName}”. It is inactive until you review it.`;
